var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdHocEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.286,
    height: 68.286,
    viewBox: "0 0 68.286 68.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1483",
    "data-name": "Group 1483",
    transform: "translate(-1098 -202)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1482",
    "data-name": "Group 1482",
    transform: "translate(-9102 5509)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M30.314,44.4,38.509,36.2V32.339l-8.194,8.194ZM16.657,36.2,24.851,44.4V40.533l-8.194-8.194V36.2Zm-5.463-3.863V36.2L3,44.4V40.533ZM38.509,2.293V6.156L30.314,14.35V10.487Zm-21.851,0,8.194,8.194V14.35L16.657,6.156Zm-5.463,0V6.156L3,14.35V10.487Z",
    transform: "translate(10216.389 -5291.835)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M32.777,43.7a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,32.777,43.7Zm-27.314,0A5.463,5.463,0,1,1,0,49.166,5.463,5.463,0,0,1,5.463,43.7ZM19.12,30.046a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,19.12,30.046Zm27.314,0a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,46.434,30.046ZM32.777,13.657a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,32.777,13.657Zm-27.314,0A5.463,5.463,0,1,1,0,19.12,5.463,5.463,0,0,1,5.463,13.657ZM19.12,0a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,19.12,0ZM46.434,0a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,46.434,0Z",
    transform: "translate(10211.194 -5295.806)",
    fill: "#fe9920"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Linechart",
    transform: "translate(1098 202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Line-Chart",
    transform: "translate(8.194 8.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    d: "M30.314,44.4,38.509,36.2V32.339l-8.194,8.194ZM16.657,36.2,24.851,44.4V40.533l-8.194-8.194V36.2Zm-5.463-3.863V36.2L3,44.4V40.533ZM38.509,2.293V6.156L30.314,14.35V10.487Zm-21.851,0,8.194,8.194V14.35L16.657,6.156Zm-5.463,0V6.156L3,14.35V10.487Z",
    transform: "translate(5.194 3.97)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    "data-name": "path",
    d: "M32.777,43.7a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,32.777,43.7Zm-27.314,0A5.463,5.463,0,1,1,0,49.166,5.463,5.463,0,0,1,5.463,43.7Zm27.314,2.731a2.731,2.731,0,1,0,2.731,2.731A2.731,2.731,0,0,0,32.777,46.434Zm-27.314,0a2.731,2.731,0,1,0,2.731,2.731A2.731,2.731,0,0,0,5.463,46.434ZM19.12,30.046a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,19.12,30.046Zm27.314,0a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,46.434,30.046ZM19.12,32.777a2.731,2.731,0,1,0,2.731,2.731A2.731,2.731,0,0,0,19.12,32.777Zm27.314,0a2.731,2.731,0,1,0,2.731,2.731A2.731,2.731,0,0,0,46.434,32.777ZM32.777,13.657a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,32.777,13.657Zm-27.314,0A5.463,5.463,0,1,1,0,19.12,5.463,5.463,0,0,1,5.463,13.657Zm27.314,2.731a2.731,2.731,0,1,0,2.731,2.731A2.731,2.731,0,0,0,32.777,16.389Zm-27.314,0A2.731,2.731,0,1,0,8.194,19.12,2.731,2.731,0,0,0,5.463,16.389ZM19.12,0a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,19.12,0ZM46.434,0a5.463,5.463,0,1,1-5.463,5.463A5.463,5.463,0,0,1,46.434,0ZM19.12,2.731a2.731,2.731,0,1,0,2.731,2.731A2.731,2.731,0,0,0,19.12,2.731Zm27.314,0a2.731,2.731,0,1,0,2.731,2.731A2.731,2.731,0,0,0,46.434,2.731Z",
    fill: "#0c4767"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdHocEvent);
export default __webpack_public_path__ + "static/media/ad-hoc-event.0bb6ee550bb6bc8a478934cbbdae253e.svg";
export { ForwardRef as ReactComponent };